import React, { Component } from 'react'
import API_URL from '../../../../common/url';
import $ from "../../../../common/AjaxRequest";
import dictCache from '../../../../common/dictCache';
import Fetch from '../../../../common/Fetch';
import FomeList from './FomeList';
import moment from 'moment';
import { getMatchOption } from '../../../shared/selectFn';

export default class InvInfor extends Component {
    state = {
        params: {},
        researchProductTypeList: [],
        testeeTypeList: [],
        byStageList: [],
    };

    componentDidMount() {
        const { params } = this.props;
        this.queryConfigWithChildByType();
        this.loadTypeConfigureList();
        this.setState({
            params: { ...params }
        })
    }

    componentWillReceiveProps(nextProps) {
        const { byStageList } = this.state;
        const { params, researchProductTypeList= [] } = nextProps;
        this.setState({
            params: { ...params },
            researchProductTypeList,
            byStageList: byStageList.length ? byStageList : nextProps.byStageList || [],
        })
    }

    //研究产品类型选项
    queryConfigWithChildByType = () => {
        dictCache.getDict('CONFIG_WITH_CHILD_RESEARCH_PRODUCT_TYPE', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.evaluate.queryConfigWithChildByType,
                data: { type: 'RESEARCH_PRODUCT_TYPE' },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            this.setState({
                researchProductTypeList: res.list,
            });
        });
    }

    //受试者类型
    loadTypeConfigureList = () => {
        dictCache.getDict('TYPE_CONFIGURE', cb => {
            Fetch.post(API_URL.common.typeConfigureList)
                .then(cb)
                .catch(error => console.log(error));
        }, res => {
            this.setState({
                testeeTypeList: res.testeeTypeList,
            });
        })
    }

    //查询项目分期
    loadInvestigationByStageList = (code) => {
        if (code) {
            Fetch.post(API_URL.common.queryInvestigationByStageByMedicine, { 
                investigationMedicineType: code
            })
                .then(res => {
                    this.setState({ byStageList: res.data });
                })
                .catch(error => console.log(error));
        } else {
            this.setState({ byStageList: [] });
        }
    }

    handleChange = (value, key) => {
        const { params, researchProductTypeList } = this.state;
        const { handleParamsChange } = this.props;
        params[key] = value;
        console.log(value, key);
        switch (key) {
            case 'researchProductTypeId':
                let code = undefined;
                params.researchProductTypePCId = value.join(',');
                params.researchProductTypeIdValue = params.researchProductTypePCId ? params.researchProductTypePCId.split(',') : [];
                params.researchProductTypeIdValue = params.researchProductTypeIdValue.map(el => el = Number(el));
                params.byStageIds = undefined;
                if(value && value.length) {
                    code = researchProductTypeList.find(el => value[0] === el.evaluateConfigureId ).code;
                    params[key] = value[value.length - 1];
                    this.loadInvestigationByStageList(code)
                }else {
                    params.investigationMedicineType = undefined;
                    params[key] = undefined;
                }
                break;
            case 'byStageIds': {
                const { byStageList } = this.state;
                const { isMultipleChoice, investigationByStageId } = getMatchOption(byStageList, 'investigationByStageId', (value || '').split(',').slice(-1));
                params.byStageIds = isMultipleChoice == 1 ? value : investigationByStageId ? `${investigationByStageId}` : '';
                break;
            }
            case 'contractSign':
            case 'sponsorCompany':
                {
                    const { value: id, text } = value;
                    params[`${key}Id`] = id;
                    params[`${key}Name`] = text;
                    delete params[key];
                    break;
                }
            case 'disease':
            {
                const { value: id, text, investigationAreaName, investigationAreaId } = value;
                params[`${key}Id`] = id;
                params[`${key}Name`] = text;
                params.investigationAreaName = investigationAreaName;
                params.investigationAreaId = investigationAreaId;
                delete params[key];
                break;
            }
            case 'crcServicePlanStartTime':
                const { preparePeriod = 0, joinGroupPeriod = 0 } = params;
                params.planFirstSiteStartDate = value; //计划首家中心启动时间
                params.planFirstInGroupDate = value; //计划首例受试者入组时间
                params.planLastSiteStartDate = value ? 
                    moment(value).add(preparePeriod * 30, 'd').format('YYYY-MM-DD')
                    : ''; //计划最后一家中心启动时间
                params.planLastInGroupDate = value ? 
                    moment(value).add((preparePeriod + joinGroupPeriod) * 30, 'd').format('YYYY-MM-DD')
                    : '';//计划最后一例受试者入组时间
                break;
        }
        this.setState({ params });
        handleParamsChange(params)
    };

    queryCanChange = value => {
        const { changeData } = this.props;
        const { changeFieldList = [] } = changeData || {};
        return changeFieldList.some(changeFieldValue => changeFieldValue == value)
    }

    updateInvInforParams = () => {
        const DomConfig = this.handleDomRender();
        DomConfig.map(el => {
            const { canChange = false, changeValue, name } = el;
            if (canChange) {
                this.handleChange(changeValue, name);
            }
        });
    }

    handleDomRender = () => {
        const {
            params,
            params: {
                byStageIds: investigationByStageId,
            },
            testeeTypeList,
            byStageList,
            researchProductTypeList,
        } = this.state;
        const { changeData = {} } = this.props;
        // 没选阶段时，单独判断；选择一个时，判断是否是多选项；选择两个以上，默认可多选
        let multiplable = true;
        let showStageOther = false;
        if ((investigationByStageId || '').split(',').length === 1) {
            const { isMultipleChoice, investigationByStageName } = getMatchOption(byStageList, 'investigationByStageId', (investigationByStageId || '').split(',')[0]);
            multiplable = isMultipleChoice == 1;
            showStageOther = investigationByStageName === '其他';
        }
        const testeeTypeOption = testeeTypeList.map(el => ({ label: el.typeValue , value: el.typeConfigureId}));
        const byStageOption = byStageList.map(el => ({ label: el.investigationByStageName , value: el.investigationByStageId, disabled: (investigationByStageId || []).length ? multiplable ? el.isMultipleChoice == 0 : el.isMultipleChoice == 1 : false}));
        const researchProductTypeOption = researchProductTypeList.map(el => {
            const {
                configureValue,
                evaluateConfigureId,
                childList = [],
            } = el;
            const option = { 
                label: configureValue, 
                value: evaluateConfigureId,
            }
            if(childList.length) {
                option.children = childList.map(child => ({ 
                    label: child.configureValue , 
                    value: child.evaluateConfigureId,
                }))
            }
            return option
        });
        const Config = [{
            label: '方案编号',
            name: 'evaluateSerialNumber',
            isRed: 'evaluateSerialNumberRed',
            type: 'Input',
            required: true,
            canChange: this.queryCanChange('evaluateSerialNumber'),
            changeValue: changeData['evaluateSerialNumber'],
            changeShow: changeData['evaluateSerialNumber'],
        },{
            label: '药物编号',
            name: 'medicationCode',
            isRed: 'medicationCodeRed',
            type: 'Input',
            canChange: this.queryCanChange('medicationCode'),
            changeValue: changeData['medicationCode'],
            changeShow: changeData['medicationCode'],
        },{
            label: '合同签署方',
            name: 'contractSign',
            showName: 'contractSignName',
            isRed: 'contractSignNameRed',
            type: 'SearchRetrieve',
            canChange: this.queryCanChange('contractSignName'),
            changeValue: {
                value: changeData['contractSignId'], 
                text: changeData['contractSignName'],
            },
            changeShow: changeData['contractSignName'],
            typeProperty: {
                keyword: "customerCompanyName",
                placeholder: "输入名称检索",
                style: { width: 205 },
                params: { limit: 20 },
                url: API_URL.investigation.queryCustomerCompanyByName,
                config: { id: 'customerCompanyId', name: 'customerCompanyName' },
            },
        },{
            label: '申办方',
            name: 'sponsorCompany',
            showName: 'sponsorCompanyName',
            isRed: 'sponsorNameRed',
            type: 'SearchRetrieve',
            canChange: this.queryCanChange('sponsorName'),
            changeValue: {
                value: changeData['sponsorCompanyId'], 
                text: changeData['sponsorName'],
            },
            changeShow: changeData['sponsorName'],
            typeProperty: {
                keyword: 'customerCompanyName',
                placeholder: '输入名称检索',
                style: { width: 205 },
                params: {limit: 20, natureName: '申办方'},
                url: API_URL.investigation.queryCustomerCompanyByName,
                config: { id: 'customerCompanyId', name: 'customerCompanyName' }
            }
        },{
            label: '研究产品类型',
            name: 'researchProductTypeId',
            isRed: 'researchProductTypeNameRed',
            showName: 'researchProductTypeName',
            type: 'Cascader',
            canChange: this.queryCanChange('researchProductTypeName'),
            changeValue: changeData.researchProductTypeParentId > 0 ? [
                changeData.researchProductTypeParentId,
                changeData.researchProductTypeId 
            ] : [ 
                changeData.researchProductTypeId 
            ],
            changeShow: changeData['researchProductTypeName'],
            required: true,
            typeProperty: {
                option: researchProductTypeOption,
            },
        },{
            label: '临床分期',
            name: 'byStageIds',
            type: 'SelectMultiple',
            showName: 'investigationByStageNames',
            isRed: 'investigationByStageNamesRed',
            required: true,
            disabled: !params.researchProductTypeId,
            canChange: this.queryCanChange('investigationByStageNames'),
            changeValue: changeData['byStageIds'],
            changeShow: changeData['investigationByStageNames'],
            typeProperty: {
                option: byStageOption,
                
            },
        },{
            label: '试验药物(或器械/试剂)名称',
            name: 'investigationMedicine',
            isRed: 'investigationMedicineRed',
            canChange: this.queryCanChange('investigationMedicine'),
            changeValue: changeData['investigationMedicine'],
            changeShow: changeData['investigationMedicine'],
            required: true,
            type: 'Input',
        },{
            label: '适应症',
            name: 'disease',
            isRed: 'diseaseNameRed',
            type: 'SearchRetrieve',
            showName: 'diseaseName',
            canChange: this.queryCanChange('diseaseName'),
            changeValue: {
                value: changeData['diseaseId'], 
                text: changeData['diseaseName'],
                investigationAreaName: changeData['investigationAreaName'], 
                investigationAreaId: changeData['investigationAreaId'], 
            },
            changeShow: changeData['diseaseName'],
            required: true,
            typeProperty: {
                keyword: "keyword",
                placeholder: "输入名称检索",
                // disabled: 'isBoundBlind',
                params: { limit: 20 },
                style: { width: 205 },
                url: API_URL.common.queryAllDiseaseList,
                config: { id: 'diseaseId', name: 'diseaseName', show: 'disease' },
            },
        },{
            label: '治疗领域',
            name: 'investigationAreaName',
            isRed: 'investigationAreaNameRed',
            type: 'text',
        },{
            label: '受试者类型',
            name: 'testeeId',
            showName: 'testeeName',
            isRed: 'testeeNameRed',
            type: 'Select',
            canChange: this.queryCanChange('testeeName'),
            changeValue: changeData['testeeId'],
            changeShow: changeData['testeeName'],
            required: true,
            typeProperty: {
                option: testeeTypeOption,
            },
        },{
            label: '业务线',
            name: 'lineOfBusinessString',
            isRed: 'lineOfBusinessStringRed',
            type: 'text',
        },{
            label: '项目分类',
            name: 'invTypeName',
            isRed: 'invTypeNameRed',
            type: 'text',
        },{
            label: 'CRC服务预计开始时间',
            name: 'crcServicePlanStartTime',
            isRed: 'crcServicePlanStartTimeRed',
            type: 'DatePicker',
            canChange: this.queryCanChange('crcServicePlanStartTime'),
            changeValue: changeData['crcServicePlanStartTime'],
            changeShow: changeData['crcServicePlanStartTime'],
            required: true,
        }];
        return Config
    }

    render() {
        const { params } = this.state;
        const { type, changeData } = this.props;
        return (
            <FomeList
                params={params}
                changeData={changeData}
                updateType={type}
                handleChange={this.handleChange}
                DomConfig={this.handleDomRender()}
            />
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/clinicalEvaluationRecord/components/InvInfor.js